<template>
  <b-sidebar
    id="guide_book"
    class="guide-body"
    right
    no-header-close
    z-index="10000"
    no-header
    backdrop
  >
    <div v-if="!sessionBooked" class="container">
      <div class="bar-header">
        <span></span>
        <div class="title d-flex justify-content-center align-items-center">
          <img
            src="@/assets/journeybinder_logo.png"
            alt="JB Logo"
            width="30"
            height="30"
          />
          <h5>Book Session</h5>
        </div>
        <div class="backSvg" v-b-toggle.guide_book>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.2929 6.29289C11.9024 6.68342 11.9024 7.31658 12.2929 7.70711L16.5858 12L12.2929 16.2929C11.9024 16.6834 11.9024 17.3166 12.2929 17.7071C12.6834 18.0976 13.3166 18.0976 13.7071 17.7071L18.7071 12.7071C19.0976 12.3166 19.0976 11.6834 18.7071 11.2929L13.7071 6.29289C13.3166 5.90237 12.6834 5.90237 12.2929 6.29289Z"
              fill="black"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.29289 6.29289C4.90237 6.68342 4.90237 7.31658 5.29289 7.70711L9.58579 12L5.29289 16.2929C4.90237 16.6834 4.90237 17.3166 5.29289 17.7071C5.68342 18.0976 6.31658 18.0976 6.70711 17.7071L11.7071 12.7071C12.0976 12.3166 12.0976 11.6834 11.7071 11.2929L6.70711 6.29289C6.31658 5.90237 5.68342 5.90237 5.29289 6.29289Z"
              fill="black"
            />
          </svg>
        </div>
      </div>
      <hr />
      <div class="content">
        <div class="user">
          <div class="user-profile">
            <img
              v-if="guide.user && guide.user.imgURL"
              :src="guide.user.imgURL"
              alt=""
            />
            <avatar
              v-if="guide.user && !guide.user.imgURL"
              :firstname="guide.user.firstname || ''"
              :lastname="guide.user.lastname || ''"
            />
          </div>
          <div
            v-if="guide.user && guide.user.firstname"
            class="text-center mt-2 pb-2"
          >
            <h5>{{ session.title }} with {{ guide.user.firstname }}</h5>
            <p>
              Welcome to my calendar. Please follow the instructions to add a
              session.
            </p>
          </div>
        </div>
        <div class="session-info">
          <span> {{ session.duration }} minutes </span>
          <span>
            {{ session.price == 0 ? "Free" : "$" + session.price }}
          </span>
        </div>
        <div class="selector">
          <div class="header">
            <div v-if="!date.value">Select a day</div>
            <span v-if="date.value">{{ date.context.selectedFormatted }}</span>
            <span
              v-if="date.value"
              class="action"
              @click="showCalender = !showCalender"
              >EDIT</span
            >
          </div>
          <b-collapse
            id="collapse-calender"
            v-model="showCalender"
            class="mt-2"
          >
            <b-calendar
              block
              locale="en-US"
              hide-header
              :min="new Date().toISOString().slice(0, 10)"
              @context="onContext"
              @input="handleSetDay"
            />
            <br />
          </b-collapse>
        </div>
        <div v-if="date.value" class="selector">
          <div class="header">
            <div v-if="!time && availbleTimes.length > 0">
              Select a time: {{ timeZone }}
            </div>
            <span v-if="time"> {{ time }} ({{ timeZone }})</span>
            <span v-if="time" class="action" @click="showTimes = !showTimes"
              >EDIT</span
            >
          </div>
          <b-collapse id="collapse-times" v-model="showTimes" class="mt-2">
            <div v-if="availbleTimes.length == 0">
              Sorry, Guide is not available on this date.
            </div>
            <div
              v-for="(time, index) in availbleTimes"
              :key="index"
              class="times"
            >
              <span @click="handleSetTime(time)"> {{ time }}</span>
            </div>
          </b-collapse>
        </div>
        <div v-show="date && time" class="selector">
          <div class="header">
            <div v-if="!cardNumber && session.price != 0">
              Enter Card Details
            </div>
            <span v-if="cardNumber && session.price != 0">{{
              cardNumber
            }}</span>
            <span
              v-if="cardNumber && session.price != 0"
              class="action"
              @click="showCheckout = !showCheckout"
              >EDIT</span
            >
          </div>
          <b-collapse
            id="collapse-checkout"
            v-model="showCheckout"
            class="mt-2"
          >
            <div
              class="card-element"
              v-if="session.price != 0"
              id="card-element"
            ></div>
            <div
              class="card-errors"
              v-if="session.price != 0"
              id="card-errors"
              role="alert"
            ></div>
            <span class="promo" v-if="session.price != 0">Use Promo code?</span>
            <b-form-input
              class="card-input"
              v-if="session.price != 0"
              v-model="promoCode"
              placeholder="PROMO CODE"
            ></b-form-input>
            <b-button
              @click="bookSession"
              class="book-btn"
              block
              variant="primary"
              ><span v-if="!processingPayment">Book</span>
              <b-spinner
                class="book-spinner"
                v-if="processingPayment"
                label="Spinning"
              ></b-spinner>
            </b-button>
          </b-collapse>
        </div>
      </div>
    </div>
    <div v-if="sessionBooked" class="session-booked">
      <img
        class="mt-5"
        src="@/assets/successful.png"
        alt="Session Booked"
        height="150"
        width="150"
      />
      <p>Confirmed</p>
      <p>
        You are booked with {{ guide.user.firstname }} {{ guide.user.lastname }}
      </p>
      <hr />
      <p>{{ this.session.duration }} Minute Session</p>
      <p>at {{ time }} ( {{ timeZone }})</p>
      <p>
        A calendar invitation has been sent to
        {{ user ? user.email : bookingForm.email }}.
      </p>
      <b-button
        @click="closeBookedSession"
        class="close-btn"
        block
        variant="primary"
        >CLOSE</b-button
      >
    </div>
  </b-sidebar>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import firebase from "firebase";
import Avatar from "./Avatar";
import sendNotification from "@/services/sendNotification";
import _config from "../../../_config.json";
var card;
export default {
  name: "Guide",
  components: {
    Avatar
  },
  props: {
    guide: {
      required: true
    },
    session: {
      required: true
    },
    onVisible: {
      type: Boolean
    },
    bookingForm: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      id: null,
      visible: false,
      userInfo: {},
      processed: false,
      guideDetails: {},
      showCalender: true,
      showTimes: false,
      showCheckout: false,
      stripe: null,
      cardNumber: "",
      cardExpiry: "",
      cardCcv: "",
      zipCode: "",
      promoCode: "",
      recurringAvailbleTimes: [],
      date: {
        value: "",
        context: {}
      },
      time: "",
      toTime: "",
      availabilty: [],
      availbleTimes: [],
      availbleSlots: [],
      bookings: [],
      sessionBooked: false,
      processingPayment: false,
      sessionsDuration: [],
      timeZone: "PST - US & Canada"
    };
  },
  mounted() {
    console.log("guide => ", this.guide);
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    })
  },
  watch: {
    session(n, o) {
      this.resetForm();
    },
    bookingForm(n) {
      if (n != null) {
        this.bookSession();
        return n;
      }
      return null;
    },
    guide(n, o) {
      if (n.user && n.user.userId) {
        this.getGuideAvailability();
        this.getGuideSessions();
        this.getGuideSessionsDuration();
      }
    },
    user(newValue, oldValue) {}
  },
  methods: {
    getGuideAvailability() {
      while (this.availabilty.length > 0) {
        this.availabilty.pop();
      }
      this.$store
        .dispatch("listings/getGuideAvailability", this.guide.user.userId)
        .then(res => {
          console.log("res => ", res.timings);
          if (res) {
            let slots = res;
            let slot = [];
            let newSlot = {};
            for (var prop in slots) {
              if (prop === "timings" && prop != "_created_at") {
                slots[prop].forEach(element => {
                  let oneEntry = {
                    date: this.formatDate(element.start_date.toDate()),
                    time: this.formatAMPM(element.start_date.toDate()),
                    toTime: this.formatAMPM(element.start_date.toDate())
                  };
                  this.availabilty.push(oneEntry);
                });
              } else if (prop != "timings" && prop != "_created_at") {
                console.log("slot name => ", prop, " slots => ", slots[prop]);
                newSlot[prop] = slots[prop].map(element => {
                  //  return await this.revertStart(element.start,element.end,prop);
                  let s_slot = {};
                  let e_slot = {};
                  s_slot.hour = element.start.slice(0, 2);
                  s_slot.mins = element.start.slice(2, 4);
                  e_slot.hour = element.end.slice(0, 2);
                  e_slot.mins = element.end.slice(2, 4);
                  let slot = { startTime: s_slot, endTime: e_slot, day: prop };
                  return slot;
                });
                this.recurringAvailbleTimes = newSlot;
              }
            }
          }
        })
        .catch(e => {
          console.log("Error in Fetching Guide Availability.", e);
        });
    },
    revertStart(start_time, end_time, prop) {
      let s_slot = {};
      let e_slot = {};
      s_slot.hour = start_time.slice(0, 2);
      s_slot.mins = start_time.slice(2, 4);
      e_slot.hour = end_time.slice(0, 2);
      e_slot.mins = end_time.slice(2, 4);
      let slot = { startTime: s_slot, endTime: e_slot, day: prop };
      return slot;
    },
    splitTime(startTime, endTime, interval) {
      const result = [startTime.toString()];
      // let time = startTime.add(interval,'m');
      let time = startTime;
      while (time.isBetween(startTime, endTime, undefined, [])) {
        let oneEntry = {
          date: this.formatDate(time.toDate()),
          time: this.formatAMPM(time.toDate())
        };
        this.availbleSlots.push(oneEntry);
        time = time.add(interval, "m");
      }
      return result;
    },
    getGuideSessions() {
      this.bookings = [];
      this.$store
        .dispatch("listings/getListGuideSessions", this.guide.user.userId)
        .then(res => {
          if (res.length > 0) {
            res.forEach(element => {
              if (element._booked_at) {
                let oneEntry = {
                  date: this.formatDate(element._booked_at.toDate()),
                  time: this.formatAMPM(element._booked_at.toDate())
                };
                this.bookings.push(oneEntry);
              }
            });
          }
        })
        .catch(e => {
          console.log("Error in Fetching Guide Sessions.", e);
        });
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    formatAMPM(date) {
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    addCardElement() {
      this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_PK);
      var elements = this.stripe.elements();
      card = elements.create("card");
      card.mount("#card-element");
      card.on("change", ({ error }) => {
        const displayError = document.getElementById("card-errors");
        if (error) {
          displayError.textContent = error.message;
        } else {
          displayError.textContent = "";
        }
      });
    },
    onContext(ctx) {
      this.date.context = ctx;
    },
    async handleSetDay(value) {
      // this.availbleTimes = [];
      // this.availbleSlots = [];
      while (this.availbleTimes.length > 0) {
        this.availbleTimes.pop();
      }
      while (this.availbleSlots.length > 0) {
        this.availbleSlots.pop();
      }
      //console.log("inside", this.availbleTimes, this.availbleSlots);
      this.availbleSlots = this.availabilty;
      //console.log("handleSetDay value => ", value);
      var dateArray = value.split("-");
      var selectedYear = dateArray[0];
      var selectedMonth = parseInt(dateArray[1], 10) - 1;
      var selectedDay = dateArray[2];
      let date = new Date(selectedYear, selectedMonth, selectedDay);
      // date = date.setDate(date.getDate() + 1);
      let day = date.toLocaleDateString("en-US", { weekday: "short" });
      let interval = this.session.duration;
      let slots = this.recurringAvailbleTimes[day.toLowerCase()];
      if (slots != undefined) {
        await slots.forEach(element => {
          let startTime = new moment(value).add({
            hour: element.startTime.hour,
            minute: element.startTime.mins
          });
          let endTime = new moment(value).add({
            hour: element.endTime.hour,
            minute: element.endTime.mins
          });
          let slicedSlots = this.splitTime(startTime, endTime, interval);
        });
      }

      this.date.value = value;
      this.time = "";
      this.showCalender = false;
      this.showTimes = true;
      for (var i = this.availbleSlots.length - 1; i >= 0; i--) {
        for (var j = 0; j < this.bookings.length; j++) {
          if (
            (this.availbleSlots[i] &&
              this.availbleSlots[i].date === this.bookings[j].date &&
              this.availbleSlots[i].time === this.bookings[j].time) ||
            (this.availbleSlots[i] &&
              this.availbleSlots[i].date === this.bookings[j].date &&
              this.matchSlotTimes(
                this.availbleSlots[i].time,
                this.bookings[j].time
              ))
          ) {
            this.availbleSlots.splice(i, 1);
          }
        }
      }
      this.availbleSlots.forEach(item => {
        if (item.date == value) {
          this.availbleTimes.push(item.time);
        }
      });
    },
    matchSlotTimes(availableTime, bookedTime) {
      let notClear = false;

      this.sessionsDuration.forEach(e => {
        if (
          new moment(availableTime, "hh:mm:ss A").format("LTS") <=
            new moment(bookedTime, "hh:mm:ss A")
              .add(e, "minute")
              .format("LTS") &&
          new moment(bookedTime, "hh:mm:ss A").format("LTS") <=
            new moment(availableTime, "hh:mm:ss A")
              .add(e, "minute")
              .format("LTS")
        ) {
          notClear = true;
        }
      });
      return notClear;
      // start <= slotEnd && slotStart <= end
    },
    getGuideSessionsDuration() {
      this.guide.profile.plans.forEach(e => {
        this.sessionsDuration.push(parseInt(e.duration));
      });
    },
    handleSetTime(time) {
      this.time = time;
      this.showCalender = false;
      this.showTimes = false;
      this.showCheckout = true;
      this.session.price != 0 ? this.addCardElement() : "";
    },
    bookSession() {
      console.log("check if user logged in => ", this.user);
      console.log("check if user logged in => ", this.bookingForm);
      if (!this.user && !this.bookingForm) {
        this.$emit("showLoginModal");
        return;
      }
      this.processingPayment = true;
      if (this.session.price != 0) {
        let func = firebase.functions().httpsCallable("createPaymentIntents");
        func()
          .then(response => {
            console.log("stripe resp => ", response);
            this.stripe
              .confirmCardPayment(response.data.client_secret, {
                payment_method: {
                  card: card,
                  billing_details: {
                    name: "Guest User"
                  }
                }
              })
              .then(result => {
                this.processingPayment = false;
                if (result.error) {
                  console.log(result.error);
                } else {
                  if (result.paymentIntent.status === "succeeded") {
                    this.sessionBooked = true;
                    this.saveBooking();
                  }
                }
              })
              .catch(error => {
                this.processingPayment = false;
                console.log(error);
              });
          })
          .catch(error => {
            this.processingPayment = false;
            console.log("here ", error);
          });
      } else {
        this.processingPayment = false;
        this.sessionBooked = true;
        this.saveBooking();
      }
    },
    saveBooking() {
      let dayTime = `${this.date.value} ${this.time}`;
      let currUser = this.user ? this.user : this.bookingForm;
      console.log(`The Current User is ${currUser}`);

      let that = this;
      this.$store
        .dispatch("listings/createSession", {
          _booked_at: new Date(dayTime),
          room_id: `${this.guide.user.userId}_guest_${moment().unix()}`,
          guide: {
            user_id: this.guide.user.userId,
            firstname: this.guide.user.firstname,
            lastname: this.guide.user.lastname,
            email: this.guide.user.email,
            imgURL: this.guide.user.imgURL
          },
          user: {
            user_id: currUser.uid ? currUser.uid : null,
            firstname: currUser.displayName
              .split(" ")
              .slice(0, -1)
              .join(" "),
            lastname: currUser.displayName
              .split(" ")
              .slice(-1)
              .join(" "),
            imgURL: currUser.photoURL ? currUser.photoURL : null,
            phonenumber: currUser.phoneNumber ? currUser.phoneNumber : null,
            email: currUser.email
          },
          plan: {
            id: this.session.id,
            price: this.session.price,
            title: this.session.title,
            summary: this.session.summary,
            duration: this.session.duration
          }
        })
        .then(() => {
          console.log("Session Saved");
          //Booker and guide will be notified on back-end
          //that.notifyBooker();

          //that.notifyGuide(); //@TODO: May move this to a trigger
        })
        .catch(error => {
          console.log(error);
        });
    },
    closeBookedSession() {
      this.sessionBooked = false;
      // this.visible = false;
      this.resetForm();
      this.$root.$emit("bv::toggle::collapse", "guide_book");
      // this.$emit("close-booking");
    },
    resetForm() {
      this.date = {
        value: "",
        context: {}
      };
      this.time = "";
      this.toTime = "";
      this.promoCode = "";
      this.showCalender = true;
      this.availbleTimes = [];
      this.getGuideAvailability();
      this.getGuideSessions();
      this.getGuideSessionsDuration();
    },
    closeMe() {
      this.resetForm();
      this.$root.$emit("bv::toggle::collapse", "guide_book");
      // this.$emit("close-booking")
    },
    notifyBooker() {
      //If guest build email
      let users = [];
      let firstname = "John";
      let lastname = "Doe";
      let email = "john@ponyengine.com";
      let templateId = this._config.mail.booking_booked_booker;

      if (this.user) {
        const user = {
          type: "member",
          user: this.user
        };
        users = [user];

        //@TODO- why no firstname on user?
        firstname = this.user.displayName
          .split(" ")
          .slice(0, -1)
          .join(" ");
        lastname = this.user.displayName
          .split(" ")
          .slice(-1)
          .join(" ");
        email = this.user.email;
      } else {
        firstname = this.bookingForm.displayName
          .split(" ")
          .slice(0, -1)
          .join(" ");
        lastname = this.bookingForm.displayName
          .split(" ")
          .slice(-1)
          .join(" ");
        email = this.bookingForm.email
          ? this.bookingForm.email
          : "test@ponyengine.com";

        const userGuest = {
          firstname: firstname ? firstname : "",
          lastname: lastname ? lastname : "",
          email: email ? email : "@"
        };

        const user = {
          type: "guest",
          user: userGuest
        };
        users = [user];
      }

      let subject = `Booking: ${firstname} ${lastname} and ${this.guide.user.firstname} ${this.guide.user.lastname}  @ ${this.time} (PST) (${email})`;

      let payload = {
        guide: {
          name: "Emanuel Colbert",
          timezone: "Pacific Standard Time"
        },
        booker: {
          name: "Mary Doe",
          email: "new@ponyengine.com",
          timezone: "Pacific Standard Time"
        },
        session: {
          id: "1234444",
          plan: "General Meeting",
          date: "Wednesday, May 3, 2020",
          time: "11:00PM",
          code: "1234444"
        }
      };

      this.sendBookedEmail(users, subject, templateId, payload);
    },
    notifyGuide() {
      //If guest build email
      let users = [];
      let firstname = "John";
      let lastname = "Doe";
      let email = "john@ponyengine.com";
      let templateId = this._config.mail.booking_booked_guide;

      if (this.guide && this.guide.user) {
        const user = {
          type: "member",
          user: this.guide.user
        };
        users = [user];

        //@TODO- why no firstname on user?
        firstname = this.guide.user.firstname;
        lastname = this.guide.user.lastname;
        email = this.guide.user.email;
      }

      let subject = `New Booking: ${firstname} ${lastname} and ${this.guide.user.firstname} ${this.guide.user.lastname}  @ ${this.time} (PST) (${email})`;

      let payload = {
        guide_name: "Savalas Colbert",
        plan_name: "General Meeting",
        session_date: "Wednesday, May 3, 2020",
        session_time: "11:00PM"
      };

      this.sendBookedEmail(users, subject, templateId, payload);
    },
    sendBookedEmail(users, subject, templateId, templateData) {
      console.log(`users ${users}`);
      console.log(`type ${users[0].type}`);
      console.log(`email ${users[0].user.email}`);
      console.log(`subject ${subject}`);
      console.log(`template-data ${templateData}`);
      console.log(`template-id ${templateId}`);

      this.isLoading = true;

      const from = "booking"; //@ToDo - Store in config
      const commTypes = ["email"];

      console.log("Send Notification");
      sendNotification(
        users,
        from,
        commTypes,
        subject,
        templateId,
        templateData,
        true
      )
        .then(res => {
          this.isLoading = false;
          console.log("sent successfully", res);
        })
        .catch(error => {
          console.log("Not sent Notification");
          this.isLoading = false;
          this.$store.dispatch("user/showNotification", {
            title: error,
            description: error.message,
            variant: "danger"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.guide-body {
  position: relative;
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #474d52;
    border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  z-index: 99;
  background-color: #fff;
  position: relative;
  .container {
    position: relative;
    padding: 0;
    * {
      z-index: 99 !important;
    }
    .bar-header {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        img {
          margin-bottom: 8px;
          margin-right: 5px;
        }
        h5 {
          font-family: "Nunito", sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
        }
      }
      .backSvg {
        margin-left: -20px;
        cursor: pointer;
        svg {
          margin-top: -12px;
          margin-right: 5px;
        }
      }
    }
    hr {
      margin-top: 3px;
      padding-left: 0;
      border: 1px solid #dddddd;
    }
    .content {
      padding: 18px;
      .user {
        .user-profile {
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 82px;
            height: 82px;
            border-radius: 50%;
            object-fit: cover;
          }
        }
        a {
          font-size: 14px;
          margin-top: 5px;
        }
      }
      .session-info {
        padding: 7px;
        border-radius: 5px;
        display: flex;
        justify-content: space-between;
        background: #dde2e9;
        color: #557efb;
        font-size: 14px;
      }
      .selector {
        margin-top: 8px;
        .header {
          display: flex;
          justify-content: space-between;
          padding: 5px;
          span {
            font-size: 13px;
            color: #557efb;
          }
          div {
            font-weight: bold;
          }
          .action {
            cursor: pointer;
          }
        }
        .times {
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            margin: 5px;
            border-radius: 5px;
            cursor: pointer;
            width: 100%;
            text-align: center;
            font-size: 14px;
            color: #557efb;
            padding-top: 5px;
            padding-bottom: 5px;
            border: 1px solid #557efb;
          }
          span:hover {
            background: #557efb;
            color: white;
          }
        }
        .card-input {
          margin-top: 5px;
          margin-bottom: 10px;
          background: #dde2e9;
          border-radius: 4px;
          border-color: transparent;
        }
        .exp {
          margin-right: 8px;
        }
        .ccv {
          margin-left: 8px;
        }
        .promo {
          padding-left: 2px;
          font-size: 10px;
          font-weight: bold;
          color: #557efb;
        }
        .book-btn {
          margin-top: 50px;
          border-radius: 50px;
          border-color: transparent;
          .book-spinner {
            width: 1.3rem;
            height: 1.3rem;
          }
        }
        .card-element {
          padding-top: 10px;
          padding-bottom: 10px;
          padding-left: 11px;
          padding-right: 11px;
          margin-top: 5px;
          margin-bottom: 5px;
          background: #dde2e9;
          border-radius: 4px;
          border-color: transparent;
        }
        .card-errors {
          font-size: 10px;
          color: red;
        }
      }
    }
  }

  .session-booked {
    text-align: center;
    padding: 15px;
    margin-top: 25px;
    p {
      color: #557efb;
    }
    h2 {
      font-weight: bold;
      color: #557efb;
    }
    h4 {
      margin-top: 40px;
    }
    .close-btn {
      margin-top: 80px;
      border-radius: 50px;
    }
  }
}
/*}*/
button:hover,
a:hover {
  box-shadow: 0px 2px 6px 0px #cbcbcb;
  cursor: pointer;
}
.guide-body {
  /* width */
  ::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #333;
    border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #222;
  }
}
</style>
